export const DetectWC = {
  methods: {
    isWC: function() {
      return process.env.WC == "true" ? true : false;
    },
    noScroll: function() {
    var ooConfig = JSON.parse(sessionStorage.getItem("OOConfig"));
    return ooConfig ? ooConfig.NoScroll : false;
    }
  }
};
